import React, { useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import { makeSelectFavoriteByMerchantId } from 'core/selectors/favorites';

import './MerchantLogoTile.scss';

function MerchantLogoTile(props) {
  const selectFavoriteByMerchantId = useMemo(makeSelectFavoriteByMerchantId, []);
  const isFavorited = useSelector(state => selectFavoriteByMerchantId(state, props.merchantId));

  const { merchantId, merchantName, merchantLogo } = props;
  const favoriteIcon = useRef(null);

  const handleClick = () => {
    const favoriteIconElement = favoriteIcon?.current?.buttonRef;
    if (favoriteIconElement) {
      favoriteIconElement.click();
    }
  };

  return (
    <div
      className={`mn_merchantLogoTile ${isFavorited ? 'mn_favorited' : ''}`}
      data-merchant-id={merchantId}
      data-merchant-name={merchantName}
      role="button"
      tabIndex="0"
      onClick={handleClick}
      aria-label={`Click to set ${merchantName} as a favorite merchant`}
    >
      <div className="mn_innerWrap">
        <FavoriteIcon
          ref={favoriteIcon}
          {...props}
        />
        <img src={merchantLogo} alt={merchantName} />
      </div>
    </div>
  );
}

MerchantLogoTile.propTypes = {
  merchantId: PropTypes.number.isRequired,
  merchantName: PropTypes.string.isRequired,
  merchantLogo: PropTypes.string.isRequired,
  tooltipEnabled: PropTypes.bool,
};

MerchantLogoTile.defaultProps = {
  tooltipEnabled: true,
};

export default MerchantLogoTile;
